import { http } from 'public/utils/http'

const axios = {
  appkey: 55844,
  cancel: true,
  axios: {
    headers: {
      'X-menu-id': '2820215716730110'
    }
  }
}

/**
 * 获取主题配置
 * @param {Object} params - 请求参数
 * @returns {Promise<Object>} 主题配置
 */
export const getThemeConfig = (params) => {
  return http('system.homeThemeConfig.get', params, axios)
}

/**
 * 保存主题配置
 * @param {Object} params - 请求参数
 * @returns {Promise<Object>} 主题配置
 */
export const saveThemeConfig = (params) => {
  return http('system.homeThemeConfig.save', params, axios)
}


/**
 * 删除主题配置
 * @param {Object} params - 请求参数
 * @returns {Promise<Object>} 主题列表
 */
export const deleteThemeConfig = (params) => {
  return http('system.homeThemeConfig.delete', params, axios)
}


/**
 * 上报用户操作
 * @param {Object} params - 请求参数
 * @returns {Promise<Object>} 主题列表
 */
export const reportUserAction = (params) => {
  return http('system.homeThemeConfig.modifyFlag', params, axios)
}



// WEBPACK FOOTER //
// ./src/layout/layout/setup/theme-system/http.js